import { ContentstackTranslationsEntry } from '~/types/common';

import { Translations } from './models';

export const mapContentstackTranslations = (
  entry: ContentstackTranslationsEntry
): Translations => ({
  carousel: {
    relatedResources: entry?.carousel_translations?.related_resources,
    relatedProducts: entry?.carousel_translations?.related_products,
    productButtonTitle: entry?.carousel_translations?.product_button_title,
    productButtonAriaLabel:
      entry?.carousel_translations?.product_button_aria_label,
    resourcesButtonTitle: entry?.carousel_translations?.resources_button_title,
    resourcesButtonAriaLabel:
      entry?.carousel_translations?.resources_button_aria_label,
  },
  card: {
    learnMoreButton: entry?.card_translations?.learn_more_button,
    downloadButton: entry?.card_translations?.download_button,
    timeUnit: entry?.card_translations?.time_unit,
    readContentType: entry?.card_translations?.read_content_type,
    watchContentType: entry?.card_translations?.watch_content_type,
    listenContentType: entry?.card_translations?.listen_content_type,
  },
  eventPage: {
    date: entry?.event_page_translations?.date,
    time: entry?.event_page_translations?.time,
    onlineEvent: entry?.event_page_translations?.online_event,
    offlineEvent: entry?.event_page_translations?.offline_event,
    onSite: entry?.event_page_translations?.on_site,
    worshop: entry?.event_page_translations?.worshop,
    presenters: entry?.event_page_translations?.presenters,
    myEvents: entry?.event_page_translations?.my_events,
  },
  professionConfirmationDialog: {
    header: entry?.profession_confirmation_modal?.header,
    bodyText: entry?.profession_confirmation_modal?.body_text,
    acceptButton: entry?.profession_confirmation_modal?.accept_button,
    declineButton: entry?.profession_confirmation_modal?.decline_button,
  },
  publishDetails: entry?.publishDetails,
  tags: entry?.tags,
});
